<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-progress-bar mode="indeterminate" *ngIf="dataSource?.loading$ | async"></mat-progress-bar>

<div fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="search-title" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 0 auto">
        <h1>{{ ( definition$ | async )?.displayname }}</h1>
        <div class="report-controls no-print" fxLayout="row" fxLayoutAlign="end center"
             *ngIf="(dataSource?.count$ | async) > 0">
            <button mat-icon-button
                    matTooltip="Download Excel"
                    (click)="downloadExcel()">
                <mat-icon svgIcon="download"></mat-icon>
            </button>
            <dash-gis-print-search [disabled]="definition.disablePrint"
                             [inputs]="printComponentInputs$ | async"></dash-gis-print-search>
        </div>
    </div>
    <h2 *ngIf="(dataSource?.count$ | async) == 0">No results found</h2>
    <div class="table-container" fxFlex="1 1 auto">
        <ng-container *ngIf="definition$ | async; let definition">
            <table mat-table #table matSort
                   (matSortChange)="onSort($event)"
                   [dataSource]="dataSource">

                <ng-container matColumnDef="zoom" *ngIf="mapEnabled">
                    <th mat-header-cell *matHeaderCellDef>Zoom</th>
                    <td mat-cell *matCellDef="let fieldData">
                        <dash-gis-zoom-button [zoomLayer]="fieldData['DB_LAYER_ID'] || definition.layer"
                                        [zoomObjectKey]="fieldData['DB_FEATURE_ID']"
                                        [zoomObjectField]="definition.objectkey"></dash-gis-zoom-button>
                    </td>
                </ng-container>
                <ng-container *ngFor="let resultField of definition.resultFields" matColumnDef="{{resultField.name}}">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{resultField.displayName}}</th>
                    <td mat-cell *matCellDef="let fieldData" [ngSwitch]="resultField.type">
                        <ng-container *ngSwitchCase="'string'">{{fieldData[resultField.name]}}</ng-container>
                        <ng-container *ngSwitchCase="'int'">{{fieldData[resultField.name]}}</ng-container>
                        <ng-container *ngSwitchCase="'float'">{{fieldData[resultField.name] | number: '1.2-5' }}</ng-container>
                        <ng-container *ngSwitchCase="'date'">{{fieldData[resultField.name] | date:'yyyy-MM-dd' }}</ng-container>
                        <ng-container *ngSwitchDefault>{{resultField.type}}</ng-container>
                    </td>
                </ng-container>

                <!-- totals -->
                <ng-container *ngFor="let fieldName of displayedColumns; let i = index"
                              [matColumnDef]="'total_' + fieldName">
                    <ng-container *ngIf="definition.totalFields">
                        <ng-container [ngSwitch]="getTotalsCellDisplay(fieldName, i)">
                            <ng-container *ngSwitchCase="'label'">
                                <td mat-footer-cell class="label" *matFooterCellDef>Totals:</td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'value'">
                                <td mat-footer-cell class="value" *matFooterCellDef>
                                    <ng-container *ngIf="dataSource.totals$ | async as totals">
                                        {{ totalsValue(totals, fieldName) | number: '1.0-2' }}
                                    </ng-container>
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <td mat-footer-cell class="default" *matFooterCellDef></td>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <!-- averages -->
                <ng-container *ngFor="let fieldName of displayedColumns; let i = index"
                              [matColumnDef]="'average_' + fieldName">
                    <ng-container *ngIf="definition.averageFields">
                        <ng-container [ngSwitch]="getAveragesCellDisplay(fieldName, i)">
                            <ng-container *ngSwitchCase="'label'">
                                <td mat-footer-cell *matFooterCellDef>Averages:</td>
                            </ng-container>
                            <ng-container *ngSwitchCase="'value'">
                                <td mat-footer-cell *matFooterCellDef>
                                    <ng-container *ngIf="dataSource.averages$ | async as averages">
                                        {{ averagesValue(averages, fieldName) | number: '1.0-2' }}
                                    </ng-container>
                                </td>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <td mat-footer-cell *matFooterCellDef></td>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <ng-container *ngIf="definition.totalFields">
                    <tr mat-footer-row *matFooterRowDef="totalsColumnsToDisplay"></tr>
                </ng-container>
                <ng-container *ngIf="definition.averageFields">
                    <tr mat-footer-row *matFooterRowDef="averagesColumnsToDisplay"></tr>
                </ng-container>
            </table>
        </ng-container>
    </div>
    <mat-paginator [hidePageSize]="(dataSource?.count$ | async) <= (paging$|async)?.limit"
                   [pageSize]="(paging$|async)?.limit"
                   [pageIndex]="(paging$|async)?.page"
                   [pageSizeOptions]="pageOptions.values"
                   [length]="dataSource?.count$ | async"
                   (page)="onPage($event)" fxFlex="0 0 48px">
    </mat-paginator>
</div>
